module.exports = __webpack_public_path__ + "img/icon_display.41608eb6.svg";